var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1136",
    "data-name": "Group 1136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 20,
    height: 20,
    fill: "#15345a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-comment-alt",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M16.667,0H3.333A3.333,3.333,0,0,0,0,3.333v10a3.333,3.333,0,0,0,3.333,3.333H5.75L9.459,19.8a.833.833,0,0,0,1.077,0l3.714-3.136h2.417A3.333,3.333,0,0,0,20,13.333v-10A3.333,3.333,0,0,0,16.667,0Zm1.667,13.333A1.667,1.667,0,0,1,16.667,15H14.25a1.666,1.666,0,0,0-1.076.394L10,18.075,6.827,15.394A1.667,1.667,0,0,0,5.75,15H3.333a1.667,1.667,0,0,1-1.667-1.667v-10A1.667,1.667,0,0,1,3.333,1.667H16.667a1.667,1.667,0,0,1,1.667,1.667Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M6.833,6.667H11A.833.833,0,0,0,11,5H6.833a.833.833,0,1,0,0,1.667Z",
    transform: "translate(-1 -0.833)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M15.167,9H6.833a.833.833,0,0,0,0,1.667h8.333a.833.833,0,0,0,0-1.667Z",
    transform: "translate(-1 -1.5)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M15.167,13H6.833a.833.833,0,0,0,0,1.667h8.333a.833.833,0,0,0,0-1.667Z",
    transform: "translate(-1 -2.167)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.59f897c572db883cb74e17dc636facaf.svg";
export { ForwardRef as ReactComponent };